import { render, staticRenderFns } from "./MyJcomTableList.vue?vue&type=template&id=669ce6c4"
import script from "./MyJcomTableList.vue?vue&type=script&lang=js"
export * from "./MyJcomTableList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports